import { SOCIAL_LABELS } from "src/types";

export const addAOChartToGridElements = (
  newGridElements,
  newHiddenGridElements,
  savedTemplate,
  templateApplied,
  aggregation,
  campaignId,
  provider,
  overlapData,
) => {
  const element = {
    key: `overlap-chart-${provider}-${campaignId}`,
    label: `overlap-chart-${provider}-${campaignId}`,
    overlapData,
    name: `Chart - ${SOCIAL_LABELS[provider]}`,
    gridBoxType: "overlap-chart",
    section: `audience-overlap`,
    campaignId,
  };

  // applying saved template

  if (
    (!aggregation && campaignId === "aggregated") ||
    (aggregation && campaignId !== "aggregated")
  ) {
    newHiddenGridElements.push(element);
  } else if (savedTemplate?.length && !templateApplied) {
    if (savedTemplate.find((item) => item.i === element.label)) {
      newGridElements.push(element);
    } else {
      newHiddenGridElements.push(element);
    }
  } else {
    newGridElements.push(element);
  }
};
